export var ActivityType;
(function (ActivityType) {
    ActivityType["Usage"] = "usage";
    ActivityType["Credit"] = "credit";
})(ActivityType || (ActivityType = {}));
//# sourceMappingURL=activityType.js.map